"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M35.493 19.061l-7.859 7.984a1.46 1.46 0 0 1-2.088 0l-.208-.211a1.522 1.522 0 0 1 0-2.121L31.943 18l-6.605-6.712a1.522 1.522 0 0 1 0-2.121l.208-.211a1.46 1.46 0 0 1 2.088 0l7.859 7.984a1.517 1.517 0 0 1 0 2.121zM.507 16.939l7.86-7.984a1.46 1.46 0 0 1 2.088 0l.208.211a1.522 1.522 0 0 1 0 2.121L4.057 18l6.605 6.712a1.522 1.522 0 0 1 0 2.121l-.208.211a1.46 1.46 0 0 1-2.088 0L.507 19.061a1.517 1.517 0 0 1 0-2.122zM16.3 29.519c-.034.135-.1.169-.236.169h-2.8c-.169 0-.2-.067-.169-.2l6.639-24.7c.034-.135.067-.135.2-.135h2.831c.135 0 .169.034.135.169z" })
);

